import { useState, useEffect } from "react";
import { adminService } from "services/adminService";

const useGetAllKnowledgeDocumentSummaries = () => {
  const [fetchedKnowledgeDocuments, setFetchedKnowledgeDocuments] = useState([]);

  useEffect(() => {
    const fetchKnowledgeDocuments = async () => {
      const knowledgeDocuments = await adminService.getAllKnowledgeDocumentSummaries();
      setFetchedKnowledgeDocuments(knowledgeDocuments);
    };
    fetchKnowledgeDocuments();
  }, []);

  return { fetchedKnowledgeDocuments };
};

export default useGetAllKnowledgeDocumentSummaries;
